<template>
    <div class="grid">
        <div class="col-12 sticky">
            <div id="custom_card" class="card">
                <div class="grid justify-content-between">
                    <div class="col-12 md:col-6">
                        <div
                            class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3">
                            <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ $t("profile") }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div
                            class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3">
                           
                            <Button @click="back" class="p-button-danger" :label="$t('goback')"
                                icon="pi pi-angle-double-left" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="grid p-fluid">
                <div class="col-12 md:col-4">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex flex-column align-items-center text-center">
                                <img v-if="product.photo && product.photo!=''"
                                    :src=product.photo class="rounded-circle" width="150">
                                <img v-else class="rounded-circle" width="150" :src=barImage()  />
                                    <div class="mt-3">
                                    <h4>{{ product.worker_name ?  product.worker_name : "" }}</h4>
                                    <p class="text-secondary mb-1">{{ product.Registration_Number ?  product.Registration_Number : "" }}</p>
                                    <p class="text-muted font-size-sm">{{ product.registration_type_name ?  product.registration_type_name : "" }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h4>Address Details</h4>
                            <div class="row" v-if="product?.address?.full_address">
                                <div class="col-md-12">
                                    <h6 class="mb-0">✅ {{$t('full_address')}} : {{ product.address.full_address ?  product.address.full_address : "" }}</h6>
                                </div>   
                            </div>
                            <hr v-if="product?.address?.full_address">
                            <div class="row" v-if="product?.address?.village">
                                <div class="col-md-12">
                                    <h6 class="mb-0">✅ {{$t('village')}} : {{ product.address.village ?  product.address.village : "" }}</h6>
                                </div>   
                            </div>
                            <hr v-if="product?.address?.village">
                             <div class="row" v-if="product?.address?.taluka">
                                <div class="col-md-12">
                                    <h6 class="mb-0">✅ {{$t('taluka')}} : {{ product.address.taluka ?  product.address.taluka : "" }}</h6>
                                </div>   
                            </div>
                            <hr v-if="product?.address?.taluka">
                             <div class="row" v-if="product?.address?.city">
                                <div class="col-md-12">
                                    <h6 class="mb-0">✅ {{$t('city')}} : {{ product.address.city ?  product.address.city : "" }}</h6>
                                </div>   
                            </div>
                            <hr v-if="product?.address?.city">
                            <div class="row" v-if="product?.address?.district">
                                <div class="col-md-12">
                                    <h6 class="mb-0">✅ {{$t('district')}} : {{ product.address.district ?  product.address.district : "" }}</h6>
                                </div>   
                            </div>
                            <hr v-if="product?.address?.district">
                            <div class="row" v-if="product?.address?.pincode">
                                <div class="col-md-12">
                                    <h6 class="mb-0">✅ {{$t('pincode')}} : {{ product.address.pincode ?  product.address.pincode : "" }}</h6>
                                </div>   
                            </div>
                            <hr v-if="product?.address?.pincode">
                            <div class="row" v-if="product?.address?.contact_no">
                                <div class="col-md-12">
                                    <h6 class="mb-0">✅ {{$t('contact_no')}} : {{ product.address.contact_no ?  product.address.contact_no : "" }}</h6>
                                </div>   
                            </div>
                            <hr v-if="product?.address?.contact_no">
                            
                        </div>
                    </div>
                    
                </div>
                <div class="col-12 md:col-8">
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-3">
                                    <h6 class="mb-0">✅ {{$t('worker_name')}} : {{ product.worker_name ?  product.worker_name : "" }}</h6>
                                </div>
                                
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <h6 class="mb-0">✅ {{$t('registration_number')}} : {{ product.Registration_Number ?  product.Registration_Number : "" }}</h6>
                                </div>
                                
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <h6 class="mb-0">✅ {{$t('mobile_no')}} : {{ product.mobile_no ?  product.mobile_no : "" }}</h6>
                                </div>
                                
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <h6 class="mb-0">✅ {{$t('pan_number')}} : {{ product.PAN_Number ?  product.PAN_Number : "" }}</h6>
                                </div>
                                
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <h6 class="mb-0">✅ {{$t('aadhaar_number')}} : {{ product.Aadhaar_Number ?  product.Aadhaar_Number : "" }}</h6>
                                </div>
                                
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <h6 class="mb-0">✅ {{$t('total_experience_years')}} : {{ product.Total_Experience_Years ?  product.Total_Experience_Years : "" }}</h6>
                                </div>
                                
                            </div>
                           <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <h6 class="mb-0">✅ {{$t('total_experience_months')}} : {{ product.Total_Experience_Months ?  product.Total_Experience_Months : "" }}</h6>
                                </div>
                                
                            </div>
                           
                            
                        </div>
                    </div>
                    
                </div>
            </div>
            
        </div>
    </div>
</template>
<script scoped>
export default {
    name: 'MahatakrarProfileDetails',
    data() {
        return {
            product:''
        };
    },
    async mounted() {
        if (localStorage.getItem("product")) {
            this.product = await JSON.parse(localStorage.getItem("product"));
            localStorage.setItem("product", "");
        } else {
            this.$toast.add({
                severity: "error",
                summary: "Error!!!",
                detail: "Details Not Found",
                life: 3000,
            });
            return false;
        }
    },
    methods: {
        back() {
            this.$router.push({
                name: "WorkerProfile",
            });
        },
        barImage() {

			return 'images/pic.jpg';
		},
    },
};
</script>
<style scoped>
</style>
